<template>
  <Transition name="slide-fade">
    <div
      v-if="show"
      class="koc-view koc-item-modal"
    >
      <div
        class="koc-item-modal-overlay"
        @click="toggleModal"
      />
      <div class="koc-item-modal-content">
        <div class="koc-item-modal-content-header">
          <button
            class="koc-button koc-ripple koc-clear koc-small koc-text"
            @click="toggleModal"
          >                    
            <font-awesome-icon
              :icon="['fa', 'rectangle-xmark']"
              size="2x"
              color="var(--koc-secondary-color)"
            />       
          </button>         
        </div>
        <div class="koc-item-modal-content-info">
          <div class="koc-item-modal-content-info-image">
            <div
              v-if="state.item.type === 'course' && state.item.trailer"
              class="jwcontainer"
            >
              <div id="jwplayer" />
            </div>            
            <div v-else>
              <a :href="state.itemLink">
                <div
                  class="koc-item-modal-content-info-image-thumbnail"
                  :style="`background-image: url(${state.image})`"
                />
              </a>
            </div>
          </div>          
          <div class="koc-item-modal-content-info-main">
            <div class="koc-item-modal-content-info-main-details">
              <div
                v-if="state.item.type === 'toolkit'"
                class="koc-item-modal-content-info-main-details-toolkit koc-title koc-montserrat"
              >
                <a
                  :href="state.itemLink"
                  v-html="state.item.title"
                />
              </div>
              <div
                v-if="state.item.type === 'webcast'"
                class="koc-item-modal-content-info-main-details-webcast koc-title koc-montserrat"
              >
                <a
                  :href="state.itemLink"
                  v-html="state.item.title"
                />
              </div>
              <div
                v-if="state.item.type === 'event_session'"
                class="koc-item-modal-content-info-main-details-webcast koc-title koc-montserrat"
              >
                <a
                  :href="state.itemLink"
                  v-html="state.item.name"
                />
                <div>
                  <p v-html="FormattingService.memberDashboardLinkedInstructorArray(state.item.session_instructors)" />
                </div>  
                <div>
                  <p class="koc-item-modal-content-info-main-details-webcast koc-title koc-montserrat">
                    Session from {{ state.item.event.name }}
                  </p>  
                </div>
              </div>              
              <div
                v-if="state.item.type === 'magazine'"
                class="koc-item-modal-content-info-main-details-magazine koc-title koc-montserrat"
              >
                <div>
                  <a
                    :href="state.itemLink"
                    v-html="state.item.publication[0].content"
                  />
                </div>
                <div> 
                  <p v-html="state.item.title" />
                </div>
              </div>
              <div
                v-if="state.item.type === 'course'"
                class="koc-item-modal-content-info-main-details-course koc-title koc-montserrat"
              >
                <div>
                  <a
                    :href="state.itemLink"
                    v-html="state.item.title"
                  />
                </div>
                <div>
                  <p v-html="FormattingService.memberDashboardLinkedInstructorArray(state.item.instructors)" />
                </div>
                <div class="koc-item-modal-content-info-main-details-flex">
                  <div>Created: {{ FormattingService.formatDate(state.item.dates.created, state.item.type) }}</div>
                  <div v-if="state.item.lessons">
                    {{ item.lessons.length }} lessons <span v-if="state.item.duration"> | {{ FormattingService.formatDuration(state.item.duration) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="koc-item-modal-content-body">
          <div class="koc-item-modal-content-body-title">
            <div v-if="state.item.type === 'toolkit'">
              <p
                v-if="state.voucherCode"
                class="koc-item-modal-content-body-lessons-title"
              >
                Voucher Code: {{ state.voucherCode }}
              </p>
              <div v-html="state.item.content ? state.item.content.raw : state.excerpt" />
            </div>
            <div v-if="state.item.type === 'webcast'">
              <div v-html="state.item.content ? state.item.content.raw : state.excerpt" />
            </div>
            <div v-if="state.item.type === 'event_session'">
              <div v-html="state.item.description" />
            </div>            
            <div v-if="state.item.type === 'magazine'">
              <p class="koc-item-modal-content-body-lessons-title">
                TUTORIAL FILES
              </p>
              <div
                v-for="(download, index) in state.item.downloads"
                :key="index"
                class="koc-item-modal-content-body-download-links"
              >
                <a
                  class=""
                  :href="download.link"
                >{{ download.title }}
                </a>
              </div>            
            </div>
            <div v-if="state.item.type === 'course'">
              <p v-html="state.item.content.raw" />
              <div class="koc-item-modal-content-body-lessons">
                <p class="koc-item-modal-content-body-lessons-title">
                  LESSONS
                </p>
                <div v-if="state.item.lessons">
                  <div
                    v-for="lesson in state.item.lessons"
                    :key="lesson.id"
                    class="koc-item-modal-content-body-lessons-container"
                  >
                    <div class="koc-item-modal-content-body-lessons-container-title">
                      <div
                        class="koc-item-modal-content-body-lessons-container-title-text koc-title koc-montserrat"
                        v-html="lesson.title"
                      />
                      <div
                        class="koc-item-modal-content-body-lessons-container-title-duration"
                        v-html="FormattingService.formatDuration(lesson.duration)"
                      />
                    </div>
                    <div class="koc-item-modal-content-body-lessons-container-content">
                      <div v-html="lesson.content.raw" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script src="./modal.js"></script>
<style lang="scss" scoped src="./modal.scss"></style>